
import { useContext, useState } from 'react';
import { BorderBottomOutlined, ClearOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Button, Col, Row, Slider, Tooltip } from 'antd';
import ColorPicker, { Color } from 'antd/es/color-picker';
import { FileCenterContext, IFileCenterContext } from '@/common/components/FileCenterProvider';
import CircleAddBtn from '@/components/WorkSpace/components/CircleAddBtn';
import { customColors } from '@/components/Sidebar/constants';
import { RGBA } from '@/common/constants/interfaces';


function FontShadow() {
    const { shadow, setShadow } = useContext<IFileCenterContext>(FileCenterContext);
    // 面板是否展开收起
    const [isFold, setIsFold] = useState<boolean>(false);

    function handleAdd() {
        setShadow({
            shadowColor: RGBA.fromHex('#000000'),
            alpha: 1,
            offsetX: 1,
            offsetY: 1,
            blur: 0,
        })
    }

    function handleRemove() {
        setShadow(null)
    }

    function handleFoldChange() {
        setIsFold(!isFold)
    }

    function handleColorChange(color: Color) {
        if (!shadow) {
            return;
        }
        setShadow({
            ...shadow,
            shadowColor: RGBA.fromHex(color.toHexString()),
        })
    }

    function handleBlurChange(value: number) {
        if (!shadow) {
            return;
        }
        setShadow({
            ...shadow,
            blur: value,
        })
    }

    function handleOffsetXChange(value: number) {
        if (!shadow) {
            return;
        }
        setShadow({
            ...shadow,
            offsetX: value,
        })
    }

    function handleOffsetYChange(value: number) {
        if (!shadow) {
            return;
        }
        setShadow({
            ...shadow,
            offsetY: value,
        })
    }

    return (
        <>
            <div className='line-between'>
                <div className='text'> <BorderBottomOutlined className='margin-right-6' />投影</div>
                <div>
                    {!shadow && <CircleAddBtn onClick={handleAdd} title='添加投影' />}
                    {shadow && (
                        <div>
                            <Tooltip placement="bottom" title="删除投影配置">
                                <Button shape="circle" size="small" type="text" icon={<ClearOutlined />} onClick={handleRemove} />
                            </Tooltip>
                            {
                                isFold && (
                                    <Tooltip placement="bottom" title="展开投影配置">
                                        <Button className='margin-left-8' shape="circle" size="small" type="text" icon={<DownOutlined />} onClick={handleFoldChange} />
                                    </Tooltip>
                                )
                            }
                            {
                                !isFold && (
                                    <Tooltip placement="bottom" title="收起投影配置">
                                        <Button className='margin-left-8' shape="circle" size="small" type="text" icon={<UpOutlined />} onClick={handleFoldChange} />
                                    </Tooltip>
                                )
                            }
                        </div>

                    )}
                </div>
            </div>
            {
                (shadow && !isFold) && (
                    <div className='line-between'>
                        <div className='text'> 颜色</div>
                        <ColorPicker size='small' value={shadow.shadowColor.toHexString()} presets={customColors} onChange={handleColorChange} />
                    </div>
                )
            }

            {
                (shadow && !isFold) && (
                    <Row>
                        <Col span={6} className='text'>
                            水平偏移
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={15}
                                step={1}
                                onChange={handleOffsetXChange}
                                value={shadow.offsetX}
                            />
                        </Col>
                    </Row>
                )
            }
            {
                (shadow && !isFold) && (
                    <Row>
                        <Col span={6} className='text'>
                            竖直偏移
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={15}
                                step={1}
                                onChange={handleOffsetYChange}
                                value={shadow.offsetY}
                            />
                        </Col>
                    </Row>
                )
            }
            {
                (shadow && !isFold) && (
                    <Row>
                        <Col span={6} className='text'>
                            模糊
                        </Col>
                        <Col span={18}>
                            <Slider
                                min={0}
                                max={100}
                                step={1}
                                onChange={handleBlurChange}
                                value={shadow.blur}
                            />
                        </Col>
                    </Row>
                )
            }
        </>
    );
}

export default FontShadow;